/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useRef, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

const FixedAction = ({ action, topPosition }) => {
  const [actionNameWidth, setActionNameWidth] = useState(null);
  const actionNameRef = useRef(null);
  const { name, icon, onClick, className, fixedTo = 'right' } = action;

  useEffect(() => {
    if (actionNameRef?.current) {
      const width =
        Math.ceil(actionNameRef.current.getBoundingClientRect().width) + 10;
      setActionNameWidth(fixedTo === 'left' ? width - 60 : width);
    }
  }, [actionNameRef]);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      className={`fixed-position-container floating-action-item fx g8 actr pointer br10 p8 ${className} fixed-${fixedTo} ${
        fixedTo === 'left' ? 'frow-reverse' : ''
      }`}
      style={{
        top: `${topPosition}px`,
        ...(actionNameWidth && {
          [fixedTo]: `-${actionNameWidth}px`
        })
      }}
    >
      {icon && <SVGIcon size="sm" color="white" name={icon} />}
      <span ref={actionNameRef} className="action-name">
        <FormattedMessage id={name} />
      </span>
    </div>
  );
};

function FixedPositionActionsGroup({ position, actions, fixedTo = 'right' }) {
  if (!actions?.length) return null;

  return actions.map((action, index) => (
    <FixedAction
      key={action.name}
      action={{ ...action, fixedTo }}
      topPosition={position.top + index * 60}
    />
  ));
}

export default FixedPositionActionsGroup;
